import $ from 'jquery'

import { MessageOverlay } from './message-overlay'
import { Forms } from './forms'

$(document).on('postmark_mfa:notification:success', (e, data) => {
  const { message } = data
  if (typeof message !== 'string') throw new Error('Expected string')

  MessageOverlay.show(message, 'success', 10000)
})

$(document).on('postmark_mfa:show-form-error', (e, data) => {
  const { $element, message } = data
  if (typeof message !== 'string') throw new Error('Expected string')

  Forms.showError($element, message)
})
